// раньше цена была в нулевом элементе, но сейчас там пустая строка,
// а цена в span, который идет вторым

const extractPrice = (priceElement) => {
  const children = priceElement.childNodes;
  const hasNestedSpanPriceWithEcwidMinus =
    children.length === 2 &&
    children[1].tagName === 'SPAN' &&
    children[0].classList &&
    children[0].classList[0] === 'ec-cart-summary__price-minus';

  if (hasNestedSpanPriceWithEcwidMinus) {
    const priceWithoutMinus = children[1].textContent;
    return priceWithoutMinus;
  }

  const price = priceElement.textContent;
  return price;
};

const changePrice = (priceElement, { convertedPrice }) => {
  const children = priceElement.childNodes;
  const nestedSpanPrice =
    children.length === 2 && children[1].tagName === 'SPAN';
  if (nestedSpanPrice) {
    children[1].textContent = convertedPrice;
  } else {
    priceElement.textContent = convertedPrice;
  }
};

const matchType = (selector) =>
  selector.classList.contains('ec-cart-summary__price');

export default { matchType, extractPrice, changePrice, name: 'cartSubtotal' };
